import { useEffect } from "react";
import { Router, useRouter } from "./router";
import { AuthProvider, useAuth } from "./auth";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { AppShell } from "./layouts/AppShell";
import { ErrorBoundary } from "./components/ErrorBoundary";

function Routes() {
  const { pathname, navigate } = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    const inApp = pathname === "/app" || pathname.startsWith("/app/");
    if (inApp && !user) navigate("/login");
    else if (pathname === "/login" && user) navigate("/app/crm");
  }, [pathname, user, loading, navigate]);

  // Public landing is auth-independent — render it straight away (this is the
  // route we server-render, and it removes the blank flash while /auth/me
  // resolves). Everything below is gated on the session.
  const inApp = pathname === "/app" || pathname.startsWith("/app/");
  if (pathname !== "/login" && !inApp) return <Landing />;

  if (loading) return null;

  if (pathname === "/login") return <Login />;
  if (inApp) {
    if (!user) return null;
    return <AppShell pathname={pathname} />;
  }
  return <Landing />;
}

export function App({ initialPath }: { initialPath?: string }) {
  return (
    <AuthProvider>
      <Router initialPath={initialPath}>
        <ErrorBoundary>
          <Routes />
        </ErrorBoundary>
      </Router>
    </AuthProvider>
  );
}
